import { faBuilding } from "@fortawesome/free-solid-svg-icons";
import { SetStateAction } from "react";
import { useForm, FormProvider } from "react-hook-form";
import {
    ListarJornadaEtapaController,
    VincularEtapaJornadaController,
} from "../../../../../../../Controllers/Geral/GestaoDeCadastros/JornadaEtapa/JornadaEtapaController";
import useAsyncCallback from "../../../../../../../hooks/useAsyncCallback";
import { IJornadaEtapa } from "../../../../../../../Interfaces/Geral/GestaoDeCadastro/JornadaEtapa/JornadaEtapaInterface";
import UnForm from "../../../../../../Form";

interface ICadastroJornadaEtapaProps {
    editting?: IJornadaEtapa;
    updateList: () => void;
    idUnidade: number;
    setShow: (value: SetStateAction<boolean>) => void;
    idConta: number;
    idEtapaJornada?: number;
}

interface IFormData {
    ID_ETAPA_JORNADA: number;
}

export default function VincularJornadaEtapa(
    props: ICadastroJornadaEtapaProps
) {
    const FormMethods = useForm();

    const {
        execute: vincularJornadaEtapa,
        loading: vincularJornadaEtapaLoading,
    } = useAsyncCallback(VincularEtapaJornadaController);

    const { execute: listarJornadaEtapa } = useAsyncCallback(
        () => ListarJornadaEtapaController(true),
        []
    );

    function handleCadastrarJornadaEtapa(formData: IFormData) {
        vincularJornadaEtapa(
            props.idUnidade,
            props.idConta,
            formData.ID_ETAPA_JORNADA
        ).then(() => {
            props.updateList();
            props.setShow(false);
        });
    }

    return (
        <FormProvider {...FormMethods}>
            <UnForm
                usingContext
                handleSubmit={handleCadastrarJornadaEtapa}
                className="row"
            >
                <div className="form-group col-12 ">
                    <UnForm.LazySelect
                        getDS={(je) => je.DS_ETAPA_JORNADA}
                        getKeyValue={(je) => je.ID_ETAPA_JORNADA}
                        controller={listarJornadaEtapa}
                        name="ID_ETAPA_JORNADA"
                        label="Etapa da Jornada"
                        defaultValue={props.idEtapaJornada}
                        registerOptions={{
                            required: "Insira a etapa jornada",
                        }}
                    >
                        <option></option>
                    </UnForm.LazySelect>
                </div>
                <div className="col-12">
                    <UnForm.SubmitButton
                        outline
                        color="success"
                        iconSize="lg"
                        loading={vincularJornadaEtapaLoading}
                        wrapperClassName="col-12 m-0 p-0"
                        className="d-none font-weight-bold col-12"
                        loadingSize="sm"
                        icon={faBuilding}
                    >
                        Vincular Etapa Jornada
                    </UnForm.SubmitButton>
                </div>
            </UnForm>
        </FormProvider>
    );
}
